import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import chooseImg from "../../assets/1703947229247.jpeg";
import "./chooseezymps.css";

const chooseReasons = [
  {
    title: "Cloud-Based Efficiency",
    text: "Access and manage your entire print ecosystem from anywhere, anytime.",
  },
  {
    title: "Data-Driven Insights",
    text: "Real-time monitoring and analytics for informed business decisions.",
  },
  {
    title: "Automated Service Scheduling",
    text: "Proactive maintenance with zero downtime.",
  },
];

const ChooseEzymps = () => {
  return (
    <div className="py-5 bg-light" style={{ overflow: "hidden" }}>
      <Container>
        <Row className="align-items-center mb-3">
          <Col md={6} data-aos="fade-right">
            <div className="choose-img-wrapper">
              <img
                src={chooseImg}
                alt="Why Choose EZYMPS"
                className="zoom-hover-img"
              />
            </div>
          </Col>
          <Col md={6} data-aos="fade-left">
            <h2 className="mt-3 title-font">
              Why Choose <span className="theme-font-color ">EHSAS?</span>
            </h2>
            <p style={{ textAlign: "justify" }}>
              EHSAS stands out in the market through its comprehensive and
              integrated service model for printer management. Unlike
              traditional vendors, we don’t just supply hardware—we deliver a
              full-fledged ERP and mobile ecosystem that tracks every movement,
              service, and component of your print infrastructure.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
          {chooseReasons.map((reason, index) => (
            <Col
              key={index}
              md={4}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <Card className="h-100 shadow-sm border-0 text-center card-hover-zoom">
                <Card.Body>
                  <Card.Title className="fw-bold theme-font-color">
                    {reason.title}
                  </Card.Title>
                  <Card.Text>{reason.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ChooseEzymps;
